import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "..";
import { MonthlyQResponse } from "./monthlyQ.types";

type RequestParams = {
  abo: string;
  aff: string;
  locale: string;
  period: string;
  isoCountryCode: string;
  isoCurrencyCode: string;
};

export const monthlyQAPI = createApi({
  reducerPath: "monthlyQAPI",
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getMonthlyQAPI: builder.query<MonthlyQResponse, RequestParams>({
      query: (params) => {
        const { abo, aff, locale, period, isoCountryCode, isoCurrencyCode } = params;
        const queryParams = new URLSearchParams({
          Abo: abo,
          Aff: aff,
          Locale: locale,
          Period: period,
          IsoCountryCode: isoCountryCode,
          IsoCurrencyCode: isoCurrencyCode,
        });

        return `/incentives-v2/api/monthlyq/overview?${queryParams}`;
      },
    }),
  }),
});

export const { useGetMonthlyQAPIQuery } = monthlyQAPI;
